import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import classNames from 'classnames';
import {
	EditComboGroupContext,
	IEditComboGroupContext,
} from '../../../../../../editComboGroupState/editComboGroupContext';
import { useCompareFormData } from 'hooks/useCompareFormData';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		selectedCustomer,
		selectedRestaurants,
		selectedDishes,
		name,
		selectedComboItems,
		upperLimit,
		lowerLimit,
		translations,
		initialFormData,
	} = useContext<IEditComboGroupContext>(EditComboGroupContext);

	const containerClasses = classNames(style.container, {
		[style.visible]:
			selectedCustomer ||
			selectedRestaurants.length ||
			selectedDishes.length ||
			name ||
			selectedComboItems.length ||
			upperLimit ||
			lowerLimit,
	});

	const currentFormData = {
		selectedCustomer,
		selectedRestaurants,
		selectedDishes,
		name,
		selectedComboItems,
		upperLimit,
		lowerLimit,
		translations,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	const handleCancel = () => {
		changeTypeOfModalWindow('toConfirmFieldsClearing');
	};

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={handleCancel}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" disabled={isEqualFormData} type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
